import {
	CLEAR_NEW_PASSWORD_STATE,
	SEND_NEW_PASSWORD,
	SEND_NEW_PASSWORD_SUCCESS,
	SEND_NEW_PASSWORD_ERROR,
	CREATE_NEW_PASSWORD,
	CREATE_NEW_PASSWORD_SUCCESS,
	CREATE_NEW_PASSWORD_ERROR,
} from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();
const SEND_PASSWORD_URL = '/auth/password/recover';
const NEW_PASSWORD_URL = '/auth/password/reset';

const defaultState = () => ({
	isLoadingSendEmail: '',
	isLoadingNewPassword: '',
});

const state = defaultState();

const getters = {
	isLoadingSendEmail: (state) => state.isLoadingSendEmail === 'loading',
	isLoadingNewPassword: (state) => state.isLoadingNewPassword === 'loading',
};

const mutations = {
	[CLEAR_NEW_PASSWORD_STATE]: (state) => {
		Object.assign(state, defaultState());
	},
	[SEND_NEW_PASSWORD]: (state) => {
		state.isLoadingSendEmail = 'loading';
	},
	[SEND_NEW_PASSWORD_SUCCESS]: (state) => {
		state.isLoadingSendEmail = 'success';
	},
	[SEND_NEW_PASSWORD_ERROR]: (state) => {
		state.isLoadingSendEmail = 'error';
	},
	[CREATE_NEW_PASSWORD]: (state) => {
		state.isLoadingNewPassword = 'loading';
	},
	[CREATE_NEW_PASSWORD_SUCCESS]: (state) => {
		state.isLoadingNewPassword = 'success';
	},
	[CREATE_NEW_PASSWORD_ERROR]: (state) => {
		state.isLoadingNewPassword = 'error';
	},
};

const actions = {
	[SEND_NEW_PASSWORD]: async ({ commit }, { body, vm }) => {
		return new Promise((resolve, reject) => {
			commit(SEND_NEW_PASSWORD);

			http({
				method: 'POST',
				url: SEND_PASSWORD_URL,
				data: body,
			})
				.then((response) => {
					resolve(response);
					commit(SEND_NEW_PASSWORD_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(SEND_NEW_PASSWORD_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[CREATE_NEW_PASSWORD]: async ({ commit }, { body, vm }) => {
		return new Promise((resolve, reject) => {
			commit(CREATE_NEW_PASSWORD);

			http.defaults.headers.common.timestamp = body.timestamp;
			body['password'] = body['encryptedPassword'];
			delete body.encryptedPassword;
			delete body.timestamp;

			http({
				method: 'POST',
				url: NEW_PASSWORD_URL,
				data: body,
			})
				.then((response) => {
					http.defaults.headers.common.Authorization = `Bearer ${response.data.token}`;
					resolve(response);
					commit(CREATE_NEW_PASSWORD_SUCCESS, response.data);
				})
				.catch((error) => {
					commit(CREATE_NEW_PASSWORD_ERROR);
					reject(error);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
